export default "/imgs/falsification_scheme.png"